import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Button, Image} from '@udemy/react-core-components';
import {useUDData} from '@udemy/ud-data';

import {udLink} from '@udemy/ud-data';

interface HeroVodafoneProps {
    jumpLinkHandler(): void;
}

export const HeroVodafone = ({jumpLinkHandler}: HeroVodafoneProps) => {
    const {gettext, interpolate} = useI18n();
    const {request: udRequest} = useUDData();

    let bannerImageSuffix = '';
    if (['de', 'es', 'it', 'tr'].includes(udRequest.language)) {
        bannerImageSuffix = `-${udRequest.language}`;
    }

    return (
        <>
            <div data-purpose="hero-vodafone" className="section--hero">
                <h1 className="ud-heading-serif-xxl section-title--hero" data-purpose="hero-title">
                    {gettext('Welcome Vodafone Customers')}
                </h1>
                <p className="ud-text-md section-text--hero">
                    {interpolate(
                        gettext(
                            'Access over %(courseCount)s free online courses, from business and technology to personal development, and grow your skills.',
                        ),
                        {courseCount: 650},
                        true,
                    )}
                </p>
                <p className="ud-text-md section-text--hero section-text--hero-b">
                    {'Together We Can'}
                </p>
                <p className="ud-text-md section-text--hero">
                    <Image
                        src={udLink.toStorageStaticAsset(
                            'partnership/vodafone-free-resource/vf-logo-v2.svg',
                        )}
                        alt="Vodafone"
                        width={251}
                        height={62}
                    />
                </p>
                <Button
                    className="section-cta--hero"
                    onClick={jumpLinkHandler}
                    data-purpose="browse-courses-cta"
                >
                    {gettext('Browse free courses')}
                </Button>
            </div>

            <div className="section--hero">
                <p className="ud-text-md section-text--hero">
                    <Image
                        src={udLink.toStorageStaticAsset(
                            `partnership/vodafone-free-resource/together-we-can${bannerImageSuffix}.jpg`,
                        )}
                        alt=""
                        width={750}
                        height={237}
                    />
                </p>
                <p className="ud-text-md section-text--hero">
                    {interpolate(
                        gettext(
                            'As a valued Vodafone customer, we are excited to bring you a selection of ' +
                                'our favorite online learning courses. We have curated over %(courseCount)s courses, ' +
                                'covering a range of topics like business, technology and personal ' +
                                'development.',
                        ),
                        {courseCount: 650},
                        true,
                    )}
                </p>
                <p className="ud-text-md section-text--hero">
                    {gettext(
                        'We invite you to browse our curated list of courses. Start growing your skills.',
                    )}
                </p>
                <p className="ud-text-md section-text--hero section-text--hero-b">
                    {'Together We Can'}
                </p>
            </div>
        </>
    );
};
